import { Component, Injector, Input } from '@angular/core';
import { provideValueAccessor } from 's-ng-utils';
import { CustomFormControl, Wrapper } from 'bookraw/shared/components/form-input/wrapper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ext-textarea',
  template: `
    <mat-form-field class="full-width" [class.mat-form-field-invalid]="ngControl.invalid">
      <mat-label>{{ label }}</mat-label>
      <textarea
        matInput
        [formControl]="formControl"
        [cdkTextareaAutosize]="autosize"
        [cdkAutosizeMinRows]="minRows"
        [cdkAutosizeMaxRows]="maxRows"
        [required]="formControl.markRequired || required"
      ></textarea>
      <mat-error>{{ formControl?.getError('error') }}</mat-error>
    </mat-form-field>
    <mat-error [style]="i === 0 ? 'margin-top: -15px' : ''" *ngFor="let error of errorMessages(formControl); index as i">{{ error }}</mat-error>
  `,
  providers: [provideValueAccessor(ExtTextareaComponent)],
})
export class ExtTextareaComponent extends Wrapper {
  @Input() label: string = '';
  @Input() autosize: boolean = true;
  @Input() minRows: number = 4;
  @Input() maxRows: number = 10;
  @Input() inputName?: string = 'This field';

  constructor(
    public injector: Injector,
    public translate: TranslateService
  ) {
    super(injector);
  }

  errorMessages(formControl: CustomFormControl): string[] {
    const errorMessages: string[] = [];

    if (formControl.touched && formControl.errors) {
      if (formControl.errors['required']) errorMessages.push(this.inputName + this.translate.instant('validation.required'));
    }

    return errorMessages;
  }
}
